"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJSBridgeAction = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var useJSBridgeInstance_1 = require("./useJSBridgeInstance");
function useJSBridgeAction() {
    var _this = this;
    var jsBridge = (0, useJSBridgeInstance_1.useJSBridgeInstance)();
    var closeWebView = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.closeWebView()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var createCacheProxyUrl = React.useCallback(function (urls) { return jsBridge.createCacheProxyUrl(urls); }, [jsBridge]);
    var detectMicro = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.detectMicro()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var keepScreenLight = React.useCallback(function (enable) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.keepScreenLight(enable)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var login = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.login()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var logout = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.logout()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var minimize = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.minimize()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var openWebView = React.useCallback(function (url, way) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.openWebView(url, way)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var preload = React.useCallback(function (urls) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.preload(urls)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var saveImage2Album = React.useCallback(function (base64) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.saveImage2Album(base64)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var setLeftTopBackButton = React.useCallback(function (enable) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.setLeftTopBackButton(enable)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var getDeviceInfo = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.getDeviceInfo()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var getUserInfo = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.getUserInfo()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var setOrientation = React.useCallback(function (orientation) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.setOrientation(orientation)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var shock = React.useCallback(function (duration) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.shock(duration)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var closeLoading = React.useCallback(function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.closeLoading()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    var loadProgress = React.useCallback(function (progress) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jsBridge.loadProgress(progress)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    }); }); }, [jsBridge]);
    return {
        closeWebView: closeWebView,
        createCacheProxyUrl: createCacheProxyUrl,
        detectMicro: detectMicro,
        getDeviceInfo: getDeviceInfo,
        keepScreenLight: keepScreenLight,
        login: login,
        logout: logout,
        minimize: minimize,
        openWebView: openWebView,
        preload: preload,
        saveImage2Album: saveImage2Album,
        setLeftTopBackButton: setLeftTopBackButton,
        getUserInfo: getUserInfo,
        setOrientation: setOrientation,
        shock: shock,
        closeLoading: closeLoading,
        loadProgress: loadProgress,
    };
}
exports.useJSBridgeAction = useJSBridgeAction;
//# sourceMappingURL=useJSBridgeAction.js.map